import { Link } from 'react-router-dom'
import { Head } from 'vite-react-ssg'
import { flattenNav } from '../nav'

export default function NotFound() {
  return (
    <div className="not-found">
      <Head>
        <title>Page not found — Chosen Help</title>
        <meta name="robots" content="noindex" />
      </Head>
      <h1>Page not found</h1>
      <p>
        That URL doesn't exist (anymore). Either it moved, or you followed a
        stale link, or someone made up a URL on the spot. Try one of these:
      </p>
      <div className="card-grid">
        {flattenNav().map((leaf) => (
          <Link key={leaf.slug} to={leaf.slug} className="card">
            <p className="card-title">{leaf.title}</p>
            <p className="card-body">{leaf.description}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
